import type { TableColumnGroupDefinition } from "~types/tableColumnGroupDefinition";
import { loadFromLocalStorage } from "./loadFromLocalStorage";

export const getTableColumns = (localStorageKey: string, configuration: Array<TableColumnGroupDefinition>) => {
  const localStorageColumns = loadFromLocalStorage(localStorageKey);
  if (localStorageColumns) {
    return localStorageColumns;
  }

  return configuration.flatMap((x) => x.columns.filter((y) => y.isDefault)).map((x) => JSON.stringify(x.key));
};
